require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-wallpaper-magazine-armadale-residence.json") })
        }
      }, "path---journal-wallpaper-magazine-armadale-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-wallpaper-magazine-armadale-residence!./.cache/json/journal-wallpaper-magazine-armadale-residence.json
// module id = 556
// module chunks = 231608221292675